import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-[500px]" }
const _hoisted_2 = { class: "mb-0 text-t1" }
const _hoisted_3 = { class: "navigation" }
const _hoisted_4 = { class: "buttons-group" }

import { ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import store from '@/store'
import { triggers } from '@/scripts/global-modals-commands'
import SwordModal from '@/components/modals/SwordModal.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'OnboardingProfileMissingModal',
  props: {
    modalOpen: { type: Boolean, default: false },
    payload: { default: () => ({}) }
  },
  setup(__props: any) {

const INCOMPLETE_PROFILE_MODAL_DATA = {
  headerStr: 'copy_4438',
  bodyStr: 'copy_4439',
  dismissButtonText: 'copy_4409',
  confirmButtonText: 'copy_4410',
}

const MISSING_PROFILE_MODAL_DATA = {
  headerStr: 'copy_3492',
  bodyStr: 'copy_3493',
  dismissButtonText: 'copy_3736',
  confirmButtonText: 'copy_3735',
}

const props = __props

const router = useRouter()

const stopShowing = ref(false)

const modalContext = computed(() => props.payload?.modalContext)
const isIncompleteProfileModal = computed(() => modalContext.value === 'incompleteProfile')
const metaData = computed(() =>
  !modalContext.value || !isIncompleteProfileModal.value ? MISSING_PROFILE_MODAL_DATA : INCOMPLETE_PROFILE_MODAL_DATA,
)

function dismissIncompleteOnboardingModal() {
  store.dispatch('user/preferences/setPreference', {
    key: 'dismissOnboardingProfileWarning',
    value: true,
    remote: true,
  })
}

function closeModal() {
  if (stopShowing.value) {
    dismissIncompleteOnboardingModal()
  }
  triggers.closeOnboardingProfileMissing()
}

function next() {
  if (stopShowing.value) {
    dismissIncompleteOnboardingModal()
  }
  router.push({ name: 'remote-config' })
  closeModal()
}

return (_ctx: any,_cache: any) => {
  const _component_sword_checkbox = _resolveComponent("sword-checkbox")!
  const _component_sword_button_wuk = _resolveComponent("sword-button-wuk")!

  return (!!modalContext.value)
    ? (_openBlock(), _createBlock(SwordModal, {
        key: 0,
        header: metaData.value.headerStr,
        title: "header",
        onClose: closeModal
      }, {
        body: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t(metaData.value.bodyStr)), 1),
            _createVNode(_component_sword_checkbox, {
              modelValue: stopShowing.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((stopShowing).value = $event)),
              label: _ctx.$t('copy_2475'),
              class: "mt-8 text-start"
            }, null, 8, ["modelValue", "label"])
          ])
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_sword_button_wuk, {
                theme: "secondary",
                text: metaData.value.dismissButtonText,
                onClickNative: closeModal
              }, null, 8, ["text"]),
              _createVNode(_component_sword_button_wuk, {
                text: metaData.value.confirmButtonText,
                onClickNative: next
              }, null, 8, ["text"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["header"]))
    : _createCommentVNode("", true)
}
}

})